module.exports = __webpack_public_path__ + "static/media/kfc.4fd2ba47.png";